<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h1 class="Prelims-head" id="_idParaDest-1"><a id="_idTextAnchor000"></a>Dedication</h1>
<p class="Dedication">For Jo, Barbara<br/>†Gail, Hester, †Cathy, Aidan, Carla, Tom</p>
<p class="Dedication">In gratitude and prayer<br/>Raymond</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781398400801_EPUB-1.vue?82a710e4